import type { AppConfig } from 'nuxt/schema'

export const preAYScripts = async (config: AppConfig['adops']) => {
  const { boltive } = config
  if (boltive.scriptUrl) {
    await loadScriptAsync('head', {
      src: boltive.scriptUrl,
      key: 'boltive',
    })
  }

  // load gamera - tracks ads per minute, ad density etc
  await loadScriptAsync('head', {
    src: `https://metrics.rapidedge.io/gamera.js?ltv=1&audience=1&tpcs=1&partner=duplex`,
    key: '__gamera__',
  })

  // load liveramp - a user data module
  await loadScriptAsync(
    'head',
    {
      src: `https://launchpad-wrapper.privacymanager.io/528606c5-a8ba-42f7-be55-93209da0477d/launchpad-liveramp.js`,
      key: 'liveramp',
    },
    { defer: true }
  )
}
